import BaseComponent from "../../../../baseComponent.js";
import DatasetService from "../../../../../core/services/datasetService.js";
import styles from "./license.scss";

export default class Licenses extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      licenses: [],
      subscriptions: []
    }
  }

  componentWillMount() {
    const promises = [DatasetService.checkUserDatasetSubscription(this.props.dataset.datasetId),
      DatasetService.getLicenses(this.props.dataset.datasetId)];
    Promise.all(promises)
      .then(result => {
        this.setState({
          subscriptions: result[0],
          licenses: result[1]
        })
      });
  }

  checkLicenseSubscription(licenseId) {
    for (let i = 0; i < this.state.subscriptions.length; i++) {
      if (this.state.subscriptions[i].datasetLicense === licenseId) {
        return true;
      }
    }
    return false;
  }

  getLicenses() {
    DatasetService.getLicenses(this.props.dataset.datasetId, (response) => {
      this.setState({
        licenses: response.data
      });
    });
  }


  response(value) {
    this.getLicenses();
    this.props.response(value);
  }

  subscribeControl(value, id) {
    let state = this.state;
    for (let i = 0; i < this.state.licenses.length; i++) {
      if (this.state.licenses[i].persistenceId == id) {
        this.state.licenses[i].subscribed = value;
      }
    }

    this.setState(state);
    this.props.response(value);
  }

  handleSubscribed(subscription) {
    const copyState = this.copyState();
    copyState.subscriptions.push(subscription);
    this.setState(copyState);
    if(this.props.onSubscribed) {
      this.props.onSubscribed();
    }
  }

  handleUnsubscribed(licenseId) {
    const copyState = this.copyState();
    copyState.subscriptions = copyState.subscriptions.filter(s => s.datasetLicense !== licenseId);
    this.setState(copyState);
  }

  render() {

    // todo: Excluded group licenses until we have proper group license handling request on the server
    let licenses = this.state.licenses.filter(l => l.datasetGroup == null).map((license, index) => {
      const subscription = this.state.subscriptions.find(s => s.datasetLicense === license.persistenceId);
      return <License license={license}
                      subscription={subscription}
                      onSubscribed={this.handleSubscribed}
                      onUnsubscribed={this.handleUnsubscribed}
                      key={index} callback={this.subscribeControl}/>;
    });
    return (
      <div className={styles.container}>
        <ul className="collection with-header">
          {licenses}
        </ul>
      </div>
    )
  }
}


class License extends BaseComponent {
  constructor(props) {
    super(props);
    this.pending = false;
  }


  subscribe() {
    if (!this.pending) {
      this.pending = true;
      DatasetService.subscribeDataset(this.props.license.dataset, this.props.license.persistenceId)
        .then(subscription => {
          this.pending = false;
          this.props.onSubscribed(subscription)
        }).catch(err => {
        console.log(err);
      });
    }
  }

  unsubscribe() {
    if (!this.pending) {
      this.pending = true;
      DatasetService.unsubscribeDataset(this.props.license.dataset, this.props.license.persistenceId)
        .then(response => {
          this.pending = false;
          this.props.onUnsubscribed(this.props.license.persistenceId)
        }).catch(err => {
        console.log(err);
      });
    }
  }

  render() {
    let subscriptionButton;
    if (this.props.subscription) {
      subscriptionButton = <a className={["waves-effect waves-light btn", styles.unsubscribeBtn].join(" ")}
                              onClick={() => this.unsubscribe()}>Unsubscribe</a>;
    } else {
      subscriptionButton =
        <a className={["waves-effect waves-light btn", styles.subscribeBtn].join(" ")}
           onClick={() => this.subscribe()}>Subscribe</a>;
    }
    return (
      <li className={["collection-item", styles.license].join(" ")}>
        <div className={styles.name}>{this.props.license.description}</div>
        {subscriptionButton}
      </li>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/content/license/license.jsx